import { useMutation } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

import {
  InsurancePaymentIntentData,
  InsurancePaymentIntentRequest,
  InsurancePaymentIntentError,
} from '@/types/insurance';
import { API } from '@/utils/apiConstants';

const ORDER_DETAILS_KEY = 'orderDetails';

const orderDetails = async (
  data: InsurancePaymentIntentRequest,
): Promise<InsurancePaymentIntentData> => {
  const response = await axios.get<InsurancePaymentIntentData>(
    `${API.baseEndpoint}/api/v1/buyer_insurance/offer_on_tracking/payment_intent/order_details`,
    {
      params: data,
    },
  );

  return response.data;
};

export const useOrderDetails = () => {
  return useMutation<
    InsurancePaymentIntentData,
    AxiosError<InsurancePaymentIntentError>,
    InsurancePaymentIntentRequest
  >({
    mutationKey: [ORDER_DETAILS_KEY],
    mutationFn: orderDetails,
  });
};
